import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Descarga, DescargasService } from '../service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { HttpCamarasService } from '../../../../auxiliares/servicios/http-camaras.service';
import { fechaCelda } from '../../../../auxiliares/tabla/celdas';

@Component({
  selector: 'app-listado-descargas',
  templateUrl: './listado-descargas.component.html',
  styleUrls: ['./listado-descargas.component.scss'],
  standalone: false,
})
export class ListadoDescargasComponent implements OnInit, OnDestroy {
  helper = inject(HelperService);
  private descargasService = inject(DescargasService);
  private httpCamaras = inject(HttpCamarasService);

  public descargas: Descarga[] = [];
  public totalCount = 0;
  public descargando = false;

  // Fecha: dd/MM/yyyy HH:mm (24 h, huso del navegador)
  public fecha = fechaCelda;

  // Subscripción
  private descargasSub?: Subscription;

  private suscribirseADescargas(): void {
    this.descargasSub = this.descargasService.descargas$.subscribe(
      (descargas) => {
        // Ordenar por fecha de creación, más recientes primero
        this.descargas = [...descargas].sort((a, b) => {
          const dateA = a.fechaCreacion
            ? new Date(a.fechaCreacion).getTime()
            : 0;
          const dateB = b.fechaCreacion
            ? new Date(b.fechaCreacion).getTime()
            : 0;
          return dateB - dateA;
        });
        this.totalCount = descargas.length;
      },
    );
  }

  public async descargarArchivo(descarga: Descarga): Promise<void> {
    if (this.descargando) {
      this.helper.notifWarn('Ya hay una descarga en progreso');
      return;
    }

    if (descarga.tipo === 'excel' && descarga.ready && descarga.url) {
      const fileName = descarga.nombre
        ? `${descarga.nombre.replace(/[/\\?%*:|"<>]/g, '-')}.xlsx`
        : 'exportacion.xlsx';
      const link = document.createElement('a');
      link.href = descarga.url;
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    if (descarga.ready && descarga.idCamara && descarga.token) {
      this.descargando = true;
      try {
        this.helper.notifWarn('Descargando video...');

        // Usar el servicio con autenticación para descargar
        const blob = await this.httpCamaras.getBlob(
          `/camaras/proxy-download/${descarga.idCamara}/${descarga.token}`,
        );

        // Generar nombre de archivo
        const fileName = descarga.nombre
          ? `${descarga.nombre.replace(/[/\\?%*:|"<>]/g, '-')}.mp4`
          : `video_${descarga.token.substring(0, 8)}.mp4`;

        // Crear URL del blob y forzar descarga
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // Liberar memoria
        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 100);
        this.helper.notifSuccess('Video descargado correctamente');
      } catch (error) {
        console.error('Error al descargar el video:', error);
        this.helper.notifError('Error al descargar el video');
      } finally {
        this.descargando = false;
      }
    } else {
      this.helper.notifError('Información de descarga incompleta');
    }
  }

  public eliminarDescarga(descarga: Descarga): void {
    if (descarga.token) {
      this.descargasService.eliminarDescarga(descarga.token);
      this.helper.notifSuccess('Descarga eliminada');
    }
  }

  public formatDuracion(ms?: number): string {
    if (!ms) return '';
    const seg = Math.round(ms / 1000);
    if (seg < 60) return `${seg}s`;
    const min = Math.floor(seg / 60);
    const rem = seg % 60;
    return rem ? `${min}m ${rem}s` : `${min}m`;
  }

  public limpiarCompletadas(): void {
    this.descargasService.limpiarDescargasCompletadas();
    this.helper.notifSuccess('Descargas completadas eliminadas');
  }

  ngOnInit(): void {
    this.suscribirseADescargas();
  }

  ngOnDestroy(): void {
    this.descargasSub?.unsubscribe();
  }
}
